import React, { useState } from 'react'
import { MapContainer, TileLayer, LayersControl, GeoJSON} from 'react-leaflet'
import * as L from "leaflet";
import * as turf from '@turf/turf'
import "leaflet/dist/leaflet.css"
import { useMapEvents } from 'react-leaflet'
import UserLocate from './../UserLocate'

require('react-leaflet-markercluster/dist/styles.min.css')

const SectionMap = ({ onSelect, features, section, position, zoom, plot }) => {
    const [, setMap] = useState(null)

    const pointToLayer = (feature, latlng) => {
        return L.rectangle(L.latLng(latlng).toBounds(50))
    }

    const selectNearest = (pos) => {
        var pt = turf.point(pos)
        let nearestLayer = -1;
        let nearestDistance = 99999;
        let index= 0
        while (index < features.length) {
            const geo= features[index].geometry
            let distance= -1;
            switch (geo.type) {
                case 'LineString':
                    distance= turf.pointToLineDistance(pt, turf.lineString(geo.coordinates), { units: 'meters'})
                    break
                case 'Polygon':
                    var poly= turf.polygon(geo.coordinates)
                    var vertices = turf.explode(poly)
                    var closestVertex = turf.nearest(pt, vertices)
                    distance = turf.distance(pt, closestVertex) * 1000
                    if (turf.booleanIntersects(pt, poly)) {
                        distance= distance * -1
                    }
                    break
                default:
                    distance= turf.distance(pt, turf.point(geo.coordinates), {units: 'meters'})
                    break
            }
            if (distance < nearestDistance) {
                nearestDistance= distance
                nearestLayer= index
            }
            index++
        }
        return nearestLayer
    }

    const handleClick = (e) => {
        const selected= selectNearest([e.latlng.lng, e.latlng.lat])
        console.log(`selected water is ${selected}`)
        if (selected > -1) {
            onSelect(selected)
        }
    }
    
    const style = (feature) => {
        if (section === feature.properties.index) {
            return null
        } else {
            return { color: process.env.REACT_APP_SECONDARYCOLOR }
        }
    }


    return (
        <MapContainer center={position} zoom={zoom} scrollWheelZoom={true} style={{ height: '100%', zIndex: 0 }} whenCreated={setMap} disableDefaultUI={true}>
                <MapEvents
                    click={(e) => handleClick(e)}
                />
            <LayersControl position="topright">
                <LayersControl.BaseLayer checked name="OpenStreetMap">
                    <TileLayer
                        attribution='&copy; <a href="https://www..org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                </LayersControl.BaseLayer>
                <LayersControl.BaseLayer name="Luchtfoto">
                    <TileLayer
                        attribution='&copy; <a href="https://www.nationaalgeoregister.nl/">Nationaal Georegister</a>'
                        url="https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0/Actueel_ortho25/EPSG:3857/{z}/{x}/{y}.jpeg"
                    />
                </LayersControl.BaseLayer>
            </LayersControl>
            <GeoJSON key={new Date().getTime()} data={features} pointToLayer={pointToLayer} style={style} />
            <GeoJSON data={plot} />
            {window.location.protocol === 'https:' && <UserLocate />}
        </MapContainer>
    )
}

const MapEvents = ({click,moveend}) => {
    useMapEvents({
        click(e) {
            click(e)
        },
    });
    return null;
}


export default SectionMap
